<template>
  <div class="modal fade" id="successRegisterPoint" role="dialog">
    <div class="modal-dialog modal-dialog-35">
      <!-- Modal content-->
      <div class="modal-content modal-success">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="success-content">
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>

        <div class="modal-body">
          <h4 class="certa">Ponto marcado com sucesso!</h4>
        </div>

        <div class="modal-footer offset-top-20">
          <button v-on:click="closeModal()" class="nunito btn-yellow-save">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "success-register",
    methods: {
      closeModal() {
        this.$emit('update:changeRoute', '/');

        $('#successRegisterPoint').modal('toggle');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/views/modals/successRegisterPoint.vue